import { Pipe, PipeTransform } from "@angular/core";
import { Address } from "../address";

@Pipe({
	name: 'address'
})
export class AddressPipe implements PipeTransform {

	addressString: string = "";

    transform(value: Address, args?: boolean): string {
        this.addressString = "";
		if (value instanceof Address) {
			if (value.SubBuilding || value.BuildingName || value.BuildingNumber || value.PrimaryStreet)
				this.addressString += ((value.SubBuilding ? value.SubBuilding + " " : "") + (value.BuildingName ? value.BuildingName + " " : "") + (value.BuildingNumber ? value.BuildingNumber + " " : "") + (value.PrimaryStreet ? value.PrimaryStreet + " " : "")).trim() + ", ";
			if (value.SecondaryStreet)
				this.addressString += value.SecondaryStreet + ", ";
			if (value.DependentLocality)
				this.addressString += value.DependentLocality + ", ";
			if (value.DoubleDependentLocality)
				this.addressString += value.DoubleDependentLocality + ", ";
			if (value.PostTown)
				this.addressString += value.PostTown + ", ";
			if (value.County)
				this.addressString += value.County + ", ";
			if (value.Postcode)
				this.addressString += value.Postcode + ", ";
			if (value.Country)
				this.addressString += value.Country + ", ";

			this.addressString = this.addressString.trim();

			if (this.addressString.length > 0)
				this.addressString = this.addressString.substring(0, this.addressString.length - 1);
		}

		if (this.addressString && args) {
			this.addressString = this.addressString.replace(/, /g, "<br>");
		}

		return this.addressString;
	}

}



// WEBPACK FOOTER //
// ./src/app/brightserve/pipes/address.pipe.ts